
import React, { Component } from 'react';

import Auth from "auth"
import { arrayObject } from "ConvertKey"
import UrlServer from "configs/UrlServer"
import { APIPost, APIGet } from "services/APIRequest"
import * as Alert from "alertService"
import GridContainer from "components/Grid/GridContainer"
import GridItem from "components/Grid/GridItem"

import Autocomplete from "components/Autocomplete/Select.jsx";

//Component==================
import Chart1 from "../UsageProgression/chart1"
import Chart2 from "../UsageProgression/chart2"

import S2Chart1 from "../NPSNationwide/chart1"
import S2Chart1L3 from "../NPSNationwide/chart1L3"


import S3Chart1 from "../AVGNationwide/chart1"
import S3Chart2 from "../AVGNationwide/chart2"

var user_type_code = Auth.getUserType()
var user_dealer_code = Auth.getUserData() ? Auth.getUserData().dealer_code : 0
class Chart extends Component {
	constructor() {
		super();
		this.state = {
			selected_dealer: null,
			dealerList: null,
			mid_nps: 60.6,
			quarter: "2",
			data_year: "2021",
			max_in_quarter: null,
			total_invitation_sent: null,
			total_online_success: null,

			S3Chart1_data: null
		}
	}
	componentDidMount() {
		Alert.Loading(true)
		this.getDealerList(() => {
			Alert.LoadingClose()
			if (user_type_code == 4) {
				this.setState({
					selected_dealer: {
						label: "",
						value: user_dealer_code
					}
				}, () => {
					this.getDataAVGAll(() => {
						this.getDataChart1(() => { })
					})
				})
			}
		})
	}
	getDataChart1 = (callback = null) => {
		this.getDealerList(() => {
			var dataToSend = {
				quarter: this.state.quarter,
				data_year: this.state.data_year,
			}

			const d_l = [0, 1, 3]
			if (d_l.indexOf(user_type_code) != -1) {
				dataToSend.dealer_code = [this.state.selected_dealer.value]
			} else if (user_type_code == 4) {
				dataToSend.dealer_code = [user_dealer_code]
			}
			Alert.Loading(true)
			APIPost(UrlServer.URL_GET_GENERATEREPORTS_GET_DATA_DASHBOARD1, dataToSend, ({ datas }) => {
				Alert.LoadingClose()
				this.setState({
					max_in_quarter: datas.max_in_quarter,
					total_invitation_sent: datas.total_invitation_sent,
					total_online_success: datas.total_online_success
				})
			})
		})
	}
	getDataAVGAll = (callback = null) => {
		var where = {}
		where.dealer_code = [this.state.selected_dealer.value]
		APIPost(UrlServer.URL_GET_GENERATEREPORTS_GET_DATA_DASHBOARD3_OS1, where, ({ datas }) => {
			this.setState({
				S3Chart1_data: datas
			}, () => {
				if (callback) callback()
			})
		})
	}
	getDealerList = (callback) => {
		var scop_dealer = user_type_code == 4 ? user_dealer_code.split(",") : null
		APIPost(UrlServer.URL_POST_GET_DEALER, {}, ({ datas }) => {
			var newConvertDatas = arrayObject(datas, [
				{
					oldKey: "dealer_code",
					newKey: "value"
				},
				{
					oldKey: "branch_name",
					newKey: "label"
				}
			])
			var _newConvertDatas = []
			if (scop_dealer) {
				newConvertDatas.map((row) => {
					if (scop_dealer.indexOf(row.value) != -1) {
						_newConvertDatas.push(row)
					}
				})
			}
			this.setState({
				dealerList: scop_dealer ? _newConvertDatas : newConvertDatas
			}, () => {
				callback()
			});
		})
	}
	handleChangeAutoCompleteNormally = name => value => {
		console.log(name, value)
		this.setState({
			[name]: value,
			max_in_quarter: null
		}, () => {
			if (name == "selected_dealer" && value && value != "") {
				this.getDataAVGAll(() => {
					this.getDataChart1(() => { })
				})
			}
		})
	}
	render() {
		return (
			<div className={"card-space"}>
				<hr className="hr-s-m-0" />
				<GridContainer justify="center">
					<GridItem xs={12}>
						<br />
						{
							(user_type_code != 4 && this.state.dealerList && this.state.dealerList.length > 0) ?
								<Autocomplete
									handleChange={this.handleChangeAutoCompleteNormally}
									value={this.state.selected_dealer}
									dataList={this.state.dealerList}
									// multi
									id="selected_dealer"
									label="เลือกสาขาที่คุณมีสิทธิ์เข้าถึงข้อมูล"
								/>
								: ""
						}
					</GridItem>
					<GridItem xs={12}>
						<center>
							<h3><b>Survey Progression</b></h3>
						</center>
					</GridItem>
					<GridItem xs={12} sm={6}>
						{
							this.state.max_in_quarter != null ?
								<Chart1
									quarter={this.state.quarter}
									data_year={this.state.data_year}
									max_in_quarter={this.state.max_in_quarter}
									total_invitation_sent={this.state.total_invitation_sent}
									total_online_success={this.state.total_online_success}
									total_tele_success={this.state.total_tele_success || 0}
								/>
								: null
						}

					</GridItem>
					<GridItem xs={12} sm={6}>
						{
							this.state.max_in_quarter != null ?
								<Chart2
									max_in_quarter={this.state.max_in_quarter}
									total_invitation_sent={this.state.total_invitation_sent}
									total_online_success={this.state.total_online_success}
									total_tele_success={this.state.total_tele_success || 0}
								/>
								: null
						}
					</GridItem>
					<GridItem xs={12}>
						<hr className="hr-s" />
						<center><h3><b>AVG Dealer</b></h3></center>
					</GridItem>
					<GridItem xs={12}>
						{
							this.state.max_in_quarter != null ?
								<S2Chart1
									selected_dealer={this.state.selected_dealer ? this.state.selected_dealer.value : undefined}
								/>
								: null
						}
					</GridItem>
					<GridItem xs={12}>
						{
							this.state.max_in_quarter != null ?
								<S2Chart1L3
									dealerTypeChart={true}
									quarter_number={this.state.quarter}
									dealer_code_list={this.state.selected_dealer ? [this.state.selected_dealer.value, null] : undefined}
									mid_nps={this.state.mid_nps}
								/>
								: null
						}
					</GridItem>
					<GridItem xs={12}>
						<hr className="hr-s" />
						<center><h3><b>AVG Dealer</b></h3></center>
					</GridItem>
					<GridItem xs={6}>
						{
							this.state.max_in_quarter != null && this.state.S3Chart1_data != null ?
								<S3Chart1
									selected_dealer={this.state.selected_dealer ? this.state.selected_dealer.value : undefined}
									chart_1_data={this.state.S3Chart1_data}
								/>
								: null
						}
					</GridItem>
					<GridItem xs={6}>
						{
							this.state.max_in_quarter != null && this.state.S3Chart1_data != null ?
								<S3Chart2
									dealerTypeChart={true}
									selected_dealer={this.state.selected_dealer ? this.state.selected_dealer.value : undefined}
									level_chart_1={1}
									cerrent_quarter={this.state.quarter}
								/>
								: null
						}
					</GridItem>
				</GridContainer>
			</div >
		);
	}
}

export default Chart;